module.exports = __webpack_public_path__ + "img/9788987265186.2201f7a6.jpg";